module.exports = __webpack_public_path__ + "img/1440.9b6ed3ae.jpg";